import { useId, useState } from 'react';

import { Button, Dialog } from '../../../components/ui';
import { useLoi } from '../../../hooks/useLoi';
import { useT } from '../../../i18n';
import { loiTheoTruong } from '../../../lib/errors';
import { LoiTrongHop } from '../../tenant/components/phan-form';
import { useSuaTep } from '../hooks/useTriThuc';
import { kiemHieuLuc } from '../nghiep-vu/tri-thuc';
import type { KnowledgeFile } from '../types';
import { ChonHieuLuc } from './ChonHieuLuc';

/** Sửa khoảng hiệu lực của một tệp (`PATCH /files/{id}`). Bỏ trống cả hai là không giới hạn thời gian. */
export function FormHieuLuc({ tep, open, onClose }: { tep: KnowledgeFile; open: boolean; onClose: () => void }) {
  const { t } = useT();
  const dichLoi = useLoi();
  const formId = useId();
  const sua = useSuaTep();

  const [tu, setTu] = useState(tep.effective_from);
  const [den, setDen] = useState(tep.effective_to);
  const [loiServer, setLoiServer] = useState<{ loi: unknown; truong: Record<string, string> } | null>(null);

  const loi = kiemHieuLuc(tu, den, false);
  const coThayDoi = tu !== tep.effective_from || den !== tep.effective_to;
  const truong = loiServer?.truong ?? {};
  const loiChung = loiServer && Object.keys(truong).length === 0 ? loiServer.loi : null;

  const gui = async () => {
    if (loi || !coThayDoi || sua.isPending) return;
    setLoiServer(null);
    try {
      await sua.mutateAsync({ tep, du: { effective_from: tu, effective_to: den }, daXong: 'hieuLuc' });
      onClose();
    } catch (err) {
      setLoiServer({ loi: err, truong: loiTheoTruong(err) });
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={t('triThuc.tep.hieuLucTieuDe')}
      width={480}
      destroyOnHidden
      footer={
        <div className="space-y-3">
          {Boolean(loiChung) && <LoiTrongHop>{dichLoi(loiChung)}</LoiTrongHop>}
          <div className="flex flex-wrap justify-end gap-3">
            <Button variant="outline" size="md" onClick={onClose}>
              {t('chung.huy')}
            </Button>
            <Button variant="primary" size="md" htmlType="submit" form={formId} loading={sua.isPending} disabled={!coThayDoi}>
              {sua.isPending ? t('chung.dangLuu') : t('triThuc.tep.luuHieuLuc')}
            </Button>
          </div>
        </div>
      }
    >
      <form
        id={formId}
        noValidate
        className="space-y-4 pt-2"
        onSubmit={(e) => {
          e.preventDefault();
          void gui();
        }}
      >
        <p className="break-all text-sm font-medium text-content-primary">{tep.file_name}</p>
        <ChonHieuLuc
          tu={tu}
          den={den}
          batBuocTu={false}
          loi={loi}
          loiServer={{ tu: truong['/effective_from'], den: truong['/effective_to'] }}
          onDoi={(a, b) => {
            setTu(a);
            setDen(b);
            setLoiServer(null);
          }}
        />
        <p className="text-xs text-content-muted">{t('triThuc.tep.hieuLucGoiY')}</p>
      </form>
    </Dialog>
  );
}
